"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.splitTabcId = exports.isValidTABCPermitCode = exports.buildTabcId = exports.buildCustomerInviteLink = exports.buildCustomerAddress = void 0;
/**
 *
 * @param {string} address
 * @param {string} zip
 * @param {string} state
 * @param {string} city
 * @returns {string} - formatted address from the given parameters, in the right order
 */
const buildCustomerAddress = ({
  address,
  zip,
  state,
  city
}) => {
  return [address, city, state, zip].filter(Boolean).join(", ");
};

/**
 * @typedef {Object} InviteLinkParams
 * @property {number} companyId - id of the company
 * @property {string} subDomain - subdomain of the company
 * @property {string} domain - base domain of the app, changes based on env
 * @property {string} tabcId - TABC ID of the company
 * @property {string} [email] - email address of the user being invited
 * @property {string} [name] - name of the user being invited
 *
 * @param {InviteLinkParams} data
 *
 * @returns {string} - registration link for the user being invited with the given params
 */
exports.buildCustomerAddress = buildCustomerAddress;
const buildCustomerInviteLink = (data = {}) => {
  const {
    protocol,
    subDomain,
    domain,
    tabcId,
    email,
    name,
    companyId
  } = data;
  const params = new URLSearchParams();
  if (tabcId) {
    params.set("tabc_id", tabcId === null || tabcId === void 0 ? void 0 : tabcId.replaceAll(/\s/g, ""));
  }
  if (email) {
    params.set("email", email);
  }
  if (name) {
    params.set("name", name);
  }
  if (companyId) {
    params.set("company_id", companyId);
  }
  const baseUrl = `${protocol ?? ""}${subDomain}.${domain}`;
  if (!params.size) {
    return baseUrl;
  }
  return `${baseUrl}/signup?${params.toString()}`;
};
exports.buildCustomerInviteLink = buildCustomerInviteLink;
const isValidTABCPermitCode = (code = "") => {
  // Regular expression pattern to match the permit code format
  var pattern = /^[A-Za-z]{2}-?\d{6}$/;

  // Check if the code matches the pattern
  return pattern.test(code);
};
exports.isValidTABCPermitCode = isValidTABCPermitCode;
const buildTabcId = customer => {
  if (!customer) return null;
  const {
    aims_license_type,
    aims_id,
    tabc_id
  } = customer;
  if (!aims_license_type || !aims_id || parseInt(aims_id) < 1) {
    return tabc_id;
  }
  return `${aims_license_type}${aims_id}`;
};
exports.buildTabcId = buildTabcId;
const splitTabcId = (inputString = "") => {
  try {
    // Extract alphabetic and numeric parts
    let alphaPart = inputString === null || inputString === void 0 ? void 0 : inputString.match(/[A-Z]+/g)[0];
    let numericPart = inputString === null || inputString === void 0 ? void 0 : inputString.match(/\d+/g)[0];
    return [alphaPart, numericPart];
  } catch (err) {
    return ["", ""];
  }
};
exports.splitTabcId = splitTabcId;